import { useColorMode } from '@chakra-ui/react';
import { useFormState } from '~/hooks';

export const Header = (): JSX.Element => {
  const { colorMode, toggleColorMode } = useColorMode();
  const reset = useFormState(s => s.reset);

  return (
    <header className="bg-white dark:bg-surface-dim border-b border-slate-200 dark:border-outline-variant fixed top-0 left-0 right-0 z-50">
      <div className="flex justify-between items-center w-full px-container-padding max-w-7xl mx-auto h-16">
        <div
          className="flex items-center gap-gutter cursor-pointer"
          onClick={() => reset()}
        >
          <img
            alt="RG Provider"
            className="h-14 w-auto object-contain"
            src="https://www.rgprovider.com.br/wp-content/uploads/2023/04/logofooter.png"
          />
        </div>
        <div className="flex items-center gap-stack-md">
          <button
            onClick={toggleColorMode}
            className="p-2 text-slate-500 hover:text-primary dark:text-on-surface-variant dark:hover:text-primary transition-all active:scale-95"
            title={colorMode === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}
          >
            <span className="material-symbols-outlined">
              {colorMode === 'light' ? 'dark_mode' : 'light_mode'}
            </span>
          </button>
        </div>
      </div>
    </header>
  );
};
